import React from 'react';
import { CtaButton } from './CtaButton';
import { checkoutUrl, cta } from '../data/content';
export function FinalCta() {
  return <section className="bg-night" data-id="element-75" data-mp="vgqwwj1g32gg">
      <div className="mx-auto max-w-3xl px-5 pt-16 text-center sm:px-6 lg:pt-24" data-id="element-76" data-mp="vhiqxpfe8s4m">
        <h2 className="font-display text-[1.875rem] font-semibold leading-tight tracking-tight text-parchment sm:text-[2.6rem]" data-id="element-77" data-mp="19cumu05acon4">
          La próxima vez que necesites una Palabra de Dios, vas a saber exactamente dónde
          buscar.
        </h2>
        <p className="mx-auto mt-5 max-w-xl font-sans text-base leading-relaxed text-parchment/75 sm:text-lg" data-id="element-78" data-mp="1eetrddcrhrln">
          Prepará hoy tu Botiquín y tené cerca palabras de paz, fortaleza, confianza y
          esperanza para esos momentos en los que más las necesitás.
        </p>

        <div className="mx-auto mt-9 max-w-md" data-id="element-79" data-mp="223d01tzq46e9">
          <CtaButton size="block" href={checkoutUrl} data-id="element-80" data-mp="2245xg4csljjq">
            {cta.label}
          </CtaButton>
          <p className="mt-3 font-sans text-xs text-parchment/55 sm:text-sm" data-id="element-81" data-mp="1x64hvteks2d0">
            {cta.finalMicro}
          </p>
        </div>
      </div>
    </section>;
}